import React from "react";
import { Box, Grid } from "@mui/material";
import Admindashboardcards from "./Admindashboardcards";
import Totalbarchart from "./Toatalbarchart";
import Individualchart from "./Individualchart";
import AdminProfilesettings from "../../Settings/Adminprofilesettings";
import { useSelector } from "react-redux";
import { userSelector } from "../../user-redux/selector";
import PromoStrip from "../../PromoStrip";

const Admin_dashboard = () => {
  const { user } = useSelector(userSelector);

  return (
    <Box sx={{ width: "100%", maxWidth: "100%", overflowX: "hidden", boxSizing: "border-box" }}>
      <PromoStrip />
      <Grid container spacing={1}>
        {!user?.companyid && <AdminProfilesettings modalOnly />}
        <Grid item xs={12} sx={{ padding: "0px" }}>
          <Admindashboardcards />
        </Grid>
      </Grid>

      {/* Hard 50/50 split — CSS grid so neither chart can steal width */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "minmax(0, 1fr) minmax(0, 1fr)" },
          gap: 1,
          width: "100%",
          maxWidth: "100%",
          mt: 1,
          boxSizing: "border-box",
        }}
      >
        <Box sx={{ minWidth: 0, maxWidth: "100%", overflow: "hidden" }}>
          <Totalbarchart />
        </Box>
        <Box sx={{ minWidth: 0, maxWidth: "100%", overflow: "hidden" }}>
          <Individualchart />
        </Box>
      </Box>
    </Box>
  );
};

export default Admin_dashboard;
